import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

if ('serviceWorker' in navigator) {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    if (isLocalhost) {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/firebase-messaging-sw.js')
                .then(() => {
                    console.log('Service Worker registration success');
                })
                .catch((err) => {
                    console.error('Service Worker registration failed:', err);
                });
        });
    }
}

Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
